import { render, staticRenderFns } from "./multiple-row-text.vue?vue&type=template&id=3592fba9&scoped=true"
import script from "./multiple-row-text.vue?vue&type=script&lang=js"
export * from "./multiple-row-text.vue?vue&type=script&lang=js"
import style0 from "./multiple-row-text.vue?vue&type=style&index=0&id=3592fba9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3592fba9",
  null
  
)

export default component.exports